export const ASSISTANT_FALLBACK_MESSAGE =
  "Something went wrong on our side. Please try again in a moment. If it keeps happening, we'll need to investigate.";

// More specific fallback messages for known error types
export const ASSISTANT_ERROR_MESSAGES = {
  rateLimited: "We're experiencing high demand right now. Please try again in a moment.",
  serviceUnavailable: "The AI service is temporarily unavailable. Please try again shortly.",
  timeout: "The request took too long to process. Please try a simpler question.",
  networkError: "Unable to connect to the server. Please check your connection and try again.",
} as const;

export function getAssistantFallbackMessage(): string {
  return ASSISTANT_FALLBACK_MESSAGE;
}

/**
 * Determines a user-friendly error message based on HTTP status code or error type.
 * Falls back to the generic message if the error type is unknown.
 */
export function getAssistantErrorMessage(
  statusCode?: number,
  errorMessage?: string,
): string {
  // If we have a specific message from the server, prefer it
  if (errorMessage && errorMessage !== 'Failed to process request') {
    return errorMessage;
  }

  // Determine message based on HTTP status
  if (statusCode === 429) {
    return ASSISTANT_ERROR_MESSAGES.rateLimited;
  }
  if (statusCode === 502 || statusCode === 503 || statusCode === 504) {
    return ASSISTANT_ERROR_MESSAGES.serviceUnavailable;
  }
  if (statusCode === 408 || (errorMessage && errorMessage.toLowerCase().includes('timeout'))) {
    return ASSISTANT_ERROR_MESSAGES.timeout;
  }

  return ASSISTANT_FALLBACK_MESSAGE;
}
